import React from 'react';
import stl from './Checkbox.module.css';

const Checkbox = ({ id, checked, onChange, label }) => (
    <div className={stl.checkboxContainer}>
        <input
            type="checkbox"
            id={id}
            checked={checked}
            onChange={onChange}
            className={stl.checkboxInput}
        />
        <label htmlFor={id} className={stl.checkboxLabel}>
            <span className={stl.checkboxText}>{label}</span>
        </label>
    </div>
);

export default Checkbox;
